import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const TeacherMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const today = new Date().toISOString().split('T')[0];
    const inputFile = useRef(null);

    const initialFormState = {
        email: "",
        teacherName: "",
        gender: "",
        joiningDate: "",
        dob: "",
        address: "",
        city: "",
        qualification: "",
        district: "",
        state: "",
        pincode: "",
        contactNumber: "",
        parmanentAddress: "",
        profilePicture: '',
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        ...(instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID && { dssPrice: "" })
    }

    const [teacherData, setTeacherData] = useState(initialFormState)
    const [teacherList, setTeacherList] = useState([])
    const [editId, setEditId] = useState(null)
    const [StateList, setStateList] = useState([])
    const [CityList, setCityList] = useState([])
    const [DistList, setDistList] = useState([])


    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [teacherNameSort, setTeacherNameSort] = useState(null);
    const [joiningDateSort, setJoiningDateSort] = useState(null);
    const [dobSort, setDobSort] = useState(null);
    const [genderSort, setGenderSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["teacherName", "email", "joiningDate", "dob", "contactNumber", "gender", "qualification", "address", "sectionMasterDetails.sectionName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getStateList()
        getTeacherList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getTeacherList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setTeacherList(await searchArray("B", `/get-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(teacherList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(teacherList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > teacherList.length) {
            endIndex = teacherList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(teacherList.slice(startIndex, endIndex));
    }, [teacherList, currPage, itemsPerPage]);

    const dateFormate = (dateString) => {
        const originalDate = new Date(dateString);
        const formattedDate = originalDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        return formattedDate
    }

    function formatDate(originalDateString) {
        const originalDate = new Date(originalDateString);
        const year = originalDate.getFullYear();
        const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
        const day = originalDate.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const getStateList = () => {
        const apiUrlForInstitute = `/all-states`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setStateList(response.data.result.map((board) => {
                    return {
                        value: board.id,
                        label: board.stateName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log('Error:', errorMsg);
            });
    }

    const getTeacherList = async () => {
        try {
            const apiUrl = `/get-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
            const response = await authorizedAxiosSection.get(apiUrl);
            setTeacherList(response.data.result)
        } catch (error) {
            setTeacherList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleChangeState = (selectedOptions) => {
        setTeacherData((prevData) => {
            return {
                ...prevData,
                state: selectedOptions.label,
            }
        })

        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleEditChangeState = (selectedOptions) => {
        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleChangeDist = (selectedOptions) => {
        setTeacherData((prevData) => {
            return {
                ...prevData,
                district: selectedOptions.label,
            }
        })
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setTeacherData((prevData) => {
            if (type === 'checkbox') {
                return {
                    ...prevData,
                    [name]: checked,
                };
            } else if (name === "contactNumber") {
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 10);
                return {
                    ...prevData,
                    [name]: filteredValue,
                };
            } else if (name === 'pincode') {
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 6);
                return {
                    ...prevData,
                    [name]: filteredValue
                }
            } else if (name === 'dssPrice') {
                const filteredValue = value.replace(/[^0-9]/g, '');
                return {
                    ...prevData,
                    [name]: filteredValue
                }
            } else {
                return {
                    ...prevData,
                    [name]: value,
                };
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const mandatoryFields = Object.keys(teacherData).filter(field => !['address', 'state', 'district', 'city', 'pincode', 'profilePicture', 'parmanentAddress'].includes(field));
        return Object.values(error).every((error) => error === '') &&
            mandatoryFields.every((field) => typeof teacherData[field] === "string" ? teacherData[field] !== '' : teacherData[field]?.length !== 0);
    };

    const validateFalse = () => {
        for (const [key, value] of Object.entries(teacherData)) {
            if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode' && key !== 'profilePicture' && key !== 'parmanentAddress') {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.'
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: ''
                        }
                    })
                }
            }
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        emailRegex.test(teacherData.email) ?
            setError((prevData) => {
                return {
                    ...prevData,
                    email: '',
                }
            })
            : setError((prevData) => {
                return {
                    ...prevData,
                    email: 'Enter valid Email ID',
                }
            })
    }

    const checking = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(teacherData.email)
    }

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(teacherData)) {
                if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode' && key !== 'profilePicture' && key !== 'parmanentAddress') {
                    if (value == '' || value.length === 0) {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: 'This field is required.'
                            }
                        })
                    } else {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: ''
                            }
                        })
                    }
                }
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            emailRegex.test(teacherData.email) ?
                setError((prevData) => {
                    return {
                        ...prevData,
                        email: '',
                    }
                })
                : setError((prevData) => {
                    return {
                        ...prevData,
                        email: 'Enter valid Email ID',
                    }
                })
        }
    }, [teacherData])

    const addSection = async () => {
        if (validateForm() && checking()) {
            try {
                setLoading(true);
                const apiUrl = `/add-teacher`;
                const response = await authorizedAxiosSection.post(apiUrl, teacherData);
                await getTeacherList();
                setTeacherData(initialFormState);
                inputFile.current.value = '';
                setSaveId(response.data.result.id);
                setTeacherNameSort(null);
                setJoiningDateSort(null);
                setDobSort(null);
                setGenderSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            validateFalse();
        }
    }

    const deleteTeacher = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-teacher?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, teacherList.length);
                await getTeacherList();
                setCurrPage(page);
                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateSection = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-teacher?id=${editId}`;
            const response = await authorizedAxiosSection.put(apiUrl, teacherData);
            await getTeacherList();
            setEditId(null);
            setTeacherData(initialFormState)
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({
                text: errorMsg
            })
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (editId !== null && editId !== "" && teacherData.district !== "") {
            handleEditChangeState(teacherData.state == "" ? null : StateList.filter(option =>
                teacherData.state && teacherData.state == option.label && (option.value)
            )[0]);
        }
    }, [editId]);

    const handleUploadLogo = async (e) => {
        setLoading(true);
        const file = e.target.files[0];

        // Allowed image types
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (!file) {
            Swal.fire({
                text: "Please select a file to upload."
            });
            setLoading(false);
            return;
        }

        // Check if the selected file is an image of allowed types
        if (!allowedTypes.includes(file.type)) {
            Swal.fire({
                text: "Invalid file type! Please upload an image (JPG, JPEG, or PNG).",
                icon: "error"
            });
            setLoading(false);
            return;
        }

        try {
            const body = new FormData();
            body.append("file", file);
            const apiUrl = "uploadimage";

            const response = await authorizedAxiosCommonFileUpload.post(apiUrl, body);

            setTeacherData((prevData) => {
                if (e.target.name === 'profilePicture') {
                    return {
                        ...prevData,
                        profilePicture: response.data.url,
                    };
                }
                return prevData;
            });
        } catch (err) {
            const errorMsg = err?.response?.data?.error || "Failed to upload image. Please try again!";
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false); // End loading
        }
    };

    const handleInputReset = () => {
        setEditId('');
        setTeacherData(initialFormState);
        inputFile.current.value = '';
        setError(initialErrorState);
    }

    useEffect(() => {
        if (teacherNameSort == true || teacherNameSort == false) {
            setJoiningDateSort(null);
            setDobSort(null);
            setGenderSort(null);
        }
    }, [teacherNameSort])

    useEffect(() => {
        if (joiningDateSort == true || joiningDateSort == false) {
            setTeacherNameSort(null);
            setDobSort(null);
            setGenderSort(null);
        }
    }, [joiningDateSort])

    useEffect(() => {
        if (dobSort == true || dobSort == false) {
            setTeacherNameSort(null);
            setJoiningDateSort(null);
            setGenderSort(null);
        }
    }, [dobSort])

    useEffect(() => {
        if (genderSort == true || genderSort == false) {
            setTeacherNameSort(null);
            setJoiningDateSort(null);
            setDobSort(null);
        }
    }, [genderSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <div id='scroll-up'></div>
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Teacher Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i> Teacher Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="teacherName" className="col-form-label"><span style={{ color: "red" }}>*</span>Teacher Name :</label>
                                                    <input type="text" className="form-control" name="teacherName" value={teacherData.teacherName} onChange={handleInputChange} />
                                                    {error.teacherName && <p style={{ color: 'red' }}>{error.teacherName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="email" className="col-form-label"><span style={{ color: "red" }}>*</span>Email ID :</label>
                                                    <input type="email" className="form-control" name="email" value={teacherData.email} onChange={handleInputChange} disabled={editId} />
                                                    {error.email && <p style={{ color: 'red' }}>{error.email}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Mobile No :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="contactNumber" value={teacherData.contactNumber} onChange={handleInputChange} />
                                                    {error.contactNumber && <p style={{ color: 'red' }}>{error.contactNumber}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="teacherName" className="col-form-label"><span style={{ color: "red" }}>*</span>Qualification :</label>
                                                    <input type="text" className="form-control" name="qualification" value={teacherData.qualification} onChange={handleInputChange} />
                                                    {error.qualification && <p style={{ color: 'red' }}>{error.qualification}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Joining Date :</label>
                                                    <input type="date" className="form-control" name="joiningDate" value={teacherData.joiningDate} onChange={handleInputChange} />
                                                    {error.joiningDate && <p style={{ color: 'red' }}>{error.joiningDate}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Date Of Birth :</label>
                                                    <input type="date" className="form-control" name="dob" value={teacherData.dob} onChange={handleInputChange} max={today} />
                                                    {error.dob && <p style={{ color: 'red' }}>{error.dob}</p>}
                                                </div>

                                                <div className="col-md-6 view_content_radio_btn">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Gender :</label>
                                                    <label>
                                                        <input type="radio" name="gender" value="M" checked={teacherData.gender == "M"} onChange={handleInputChange} /> Male
                                                    </label>
                                                    <label>
                                                        <input type="radio" name="gender" value="F" checked={teacherData.gender == "F"} onChange={handleInputChange} /> Female
                                                    </label>
                                                </div>
                                                {error.gender && <p style={{ color: 'red' }}>{error.gender}</p>}
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Address :</label>
                                                    <input type="text" className="form-control" name="address" value={teacherData.address} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">State :</label>
                                                    <Select
                                                        value={teacherData.state == "" ? null : StateList.filter(option =>
                                                            teacherData.state && teacherData.state == option.label && (option.value)
                                                        )[0]}

                                                        name="state"
                                                        options={StateList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeState}
                                                    />
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">District :</label>
                                                    <Select
                                                        value={teacherData.district == "" ? null : DistList.filter(option =>
                                                            teacherData.district && teacherData.district == option.label && (option.value)
                                                        )[0]}
                                                        name="district"
                                                        options={DistList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeDist}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">City :</label>
                                                    <input type="text" className="form-control" name="city" value={teacherData.city} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Pincode :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="pincode" value={teacherData.pincode} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Permanent Address :</label>
                                                    <input type="text" className="form-control" name="parmanentAddress" value={teacherData.parmanentAddress} onChange={handleInputChange} />
                                                </div>
                                                {instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID && <div className="col-md-6">
                                                    <label htmlFor="dssPrice" className="col-form-label"><span style={{ color: "red" }}>*</span>{/*Price (INR):*/}DSS Price:</label>
                                                    <div className="input-group">
                                                        <span className="input-group-text">₹</span>
                                                        <input type="text" className="form-control" name="dssPrice" value={teacherData.dssPrice} onChange={handleInputChange} min="0" placeholder="Enter price" />
                                                    </div>
                                                    {error.dssPrice && <p style={{ color: 'red' }}>{error.dssPrice}</p>}
                                                </div>}
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Upload Profile Picture :</label>
                                                    <input type="file" className="form-control" name="profilePicture" onChange={handleUploadLogo} ref={inputFile} />
                                                    {teacherData.profilePicture && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        Selected Profile: <img src={`${teacherData.profilePicture}`} alt="" width="70" height="60" />
                                                    </div>
                                                )}
                                                </div>
                                                
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addSection}>Save</button>}
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSection} disabled={!editId}>Update</button>)}
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Teacher Name
                                                                            <SortIcon sortState={teacherNameSort} setSortState={setTeacherNameSort} setData={setTeacherList} setCurrPage={setCurrPage} sortingPath={"teacherName"} />
                                                                        </th>
                                                                        <th scope="col">Email Id</th>
                                                                        <th scope="col">
                                                                            joining Date
                                                                            <SortIcon sortState={joiningDateSort} setSortState={setJoiningDateSort} setData={setTeacherList} setCurrPage={setCurrPage} sortingPath={"joiningDate"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date Of Birth
                                                                            <SortIcon sortState={dobSort} setSortState={setDobSort} setData={setTeacherList} setCurrPage={setCurrPage} sortingPath={"dob"} />
                                                                        </th>
                                                                        <th scope="col">Mobile No</th>
                                                                        <th scope="col">
                                                                            Gender
                                                                            <SortIcon sortState={genderSort} setSortState={setGenderSort} setData={setTeacherList} setCurrPage={setCurrPage} sortingPath={"gender"} />
                                                                        </th>
                                                                        <th scope='col'>Qualification</th>
                                                                        <th scope="col">Address</th>
                                                                        <th scope="col">Section</th>
                                                                        {instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID && <th scope='col'>DSS Price</th>}
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((section, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{section.teacherName}</td>
                                                                                        <td>{section.email}</td>
                                                                                        <td>{dateFormate(section.joiningDate)}</td>
                                                                                        <td>{dateFormate(section.dob)}</td>
                                                                                        <td>{section.contactNumber}</td>
                                                                                        <td>{section.gender}</td>
                                                                                        <td>{section.qualification}</td>
                                                                                        <td>{section.address}</td>
                                                                                        <td>{section.sectionMasterDetails.sectionName}</td>
                                                                                        {instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID && <td>₹ {section.dssPrice}</td>}
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }} onClick={() => {
                                                                                                setTeacherData({
                                                                                                    address: section.address,
                                                                                                    state: section.state,
                                                                                                    city: section.city,
                                                                                                    district: section.district,
                                                                                                    pincode: section.pincode,
                                                                                                    contactNumber: section.contactNumber,
                                                                                                    email: section.email,
                                                                                                    teacherName: section.teacherName,
                                                                                                    gender: section.gender,
                                                                                                    qualification: section.qualification,
                                                                                                    joiningDate: formatDate(section.joiningDate),
                                                                                                    dob: formatDate(section.dob),
                                                                                                    parmanentAddress: section.parmanentAddress,
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    sectionMasterId: sectionMasterId,
                                                                                                    ...(instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID && { dssPrice: section.dssPrice }),
                                                                                                });
                                                                                                setEditId(section.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === section.id} onClick={() => deleteTeacher(section.id)}> <i class="fa-light fa-trash-can"></i></button>

                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Teacher Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={teacherList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default TeacherMaster;